module.exports = __webpack_public_path__ + "img/151167575307.1e70cc5f.jpg";